import React from 'react';
import { 
    Edit, 
    SimpleForm, 
    TextInput,
    NumberInput,
    required,
    usePermissions
} from 'react-admin';
import { FormToolbar } from "../../common/FormToolbar";
import { processPermissions } from "../../common/roleUtils";

export const ClassEdit = props => {
    const { permissions } = usePermissions();
    let propsObj = { ...props };
    
    if (permissions) {
        // Use utility function to process permissions with role-based restrictions
        const processedPermissions = processPermissions(permissions, props.resource);
        propsObj = { ...propsObj, ...processedPermissions };
    }
    
    return (
        <React.Fragment>
            <Edit label="Edit Class" {...propsObj}>
                <SimpleForm toolbar={<FormToolbar {...propsObj} hasDelete={true}/>} className="main-form">
                    <TextInput 
                        source="class_name" 
                        label='Class Name' 
                        fullWidth={true}
                        className="first_inline_input"
                        validate={[required()]} 
                        helperText="E.g., Class 9, Class 10, etc."
                    />
                    <NumberInput 
                        source="numeric_equivalent" 
                        label='Class Number' 
                        fullWidth={true}
                        className="last_inline_input"
                        validate={[required()]}
                        min={1}
                        max={12}
                        helperText="Numeric value (9, 10, 11, 12)"
                    />
                </SimpleForm>
            </Edit>
        </React.Fragment>
    );
}
